export const ucFirst = (str) => {
  return str ? str.replace(/_/g, ' ').replace(/(^| )(\w)/g, function (word) {
    return word.toUpperCase();
  }) : '';
};

export const getUserProfileImage = (user) => {
  return user.profile_image ? user.profile_image : 'https://ui-avatars.com/api/?name=' + encodeURIComponent(user.name)
};

export const createMarkup = (htmlContent) => {
  return { __html: htmlContent };
};

export const getTicketLockMessage = (ticket) => {
  const statusName = String(ticket?.status?.name ?? '').toLowerCase();
  const isRejected = !!ticket?.is_rejected || statusName === 'rejected';
  if (isRejected) {
    return 'This ticket is rejected. You can no longer make changes.';
  }
  const isLocked = !!ticket?.is_locked || !!ticket?.is_closed || statusName === 'closed';
  if (isLocked) {
    return 'This ticket is closed. You can no longer make changes.';
  }
  return null;
};

export const isTicketLocked = (ticket) => getTicketLockMessage(ticket) !== null;